import { RouterProvider } from 'react-router';
import { QueryProvider } from './providers/QueryProvider';
import { SessionProvider } from './providers/SessionProvider';
import { TooltipProvider } from '@/shared/ui/Tooltip';
import { Toaster } from '@/shared/ui/Toaster';
import { ErrorDialog } from '@/shared/ui/ErrorDialog';
import { DialogHost } from '@/shared/ui/DialogHost';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';
import { router } from './router';
import { ImpersonationBanner } from '@/features/impersonation/ImpersonationBanner';

export function App() {
  return (
    <ErrorBoundary>
      <QueryProvider>
        <TooltipProvider>
          <SessionProvider>
            <RouterProvider router={router} />
            <Toaster />
            {/* Veritabanından gelen yapılandırılmış hatalar bildirim yerine burada
                açılır (bkz. toastStore.error). */}
            <ErrorDialog />
            {/* Onay/uyarı pencereleri: kök seviyede, çünkü OctoLab ve Node görünümü
                ana kabuğu kullanmıyor — orada mount edilen host oralarda çalışmıyordu. */}
            <DialogHost />
            <ImpersonationBanner />
          </SessionProvider>
        </TooltipProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}
